import { render, staticRenderFns } from "./commonFooter.vue?vue&type=template&id=ae90d030&scoped=true"
import script from "./commonFooter.vue?vue&type=script&lang=js"
export * from "./commonFooter.vue?vue&type=script&lang=js"
import style0 from "./commonFooter.vue?vue&type=style&index=0&id=ae90d030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae90d030",
  null
  
)

export default component.exports